import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import { UUID } from '../../types/standard';

export const deleteActivitat = async (
  id: UUID | undefined,
): Promise<Result<boolean, APIValidationError>> => {
  return validatedApiCall<boolean>(`/api/activitats/${id}`, {
    method: 'DELETE',
    auth: true,
  });
};
